import React from "react";
import {
  WhmBox,
  WhmCard,
  WhmCardContent,
  WhmSkeleton,
} from "@securitize/reactjs-whm";

export const SettingsDevicesLoadingCard: React.FC = () => (
  <WhmCard
    variant={"outlined"}
    data-test-id="profile-settings-top-skeleton-card"
    sx={{
      width: "100%",
    }}
  >
    <WhmCardContent>
      <WhmBox
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          marginBottom: "16px",
        }}
      >
        <WhmSkeleton variant="rounded" width={120} height={20} />
        <WhmSkeleton variant="rounded" width={"100%"} height={20} />
      </WhmBox>

      <WhmBox
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <WhmSkeleton variant="rounded" width={"100%"} height={44} />
        <WhmSkeleton variant="rounded" width={"100%"} height={44} />
        <WhmSkeleton variant="rounded" width={"100%"} height={44} />
      </WhmBox>
    </WhmCardContent>
  </WhmCard>
);
